var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeAndFiltersForQuery, makeNegativeFilterForQuery, makeOrFiltersForQuery } from '../../../lib/filter';
import { makeFacetsForQuery } from '../../../lib/facet';
export const transformGetProvidersInputForApi = (input) => {
    const params = {};
    const { facet, filter, slots_facet, slots_filter } = input, inputMinusFacetFilter = __rest(input, ["facet", "filter", "slots_facet", "slots_filter"]);
    if (filter === null || filter === void 0 ? void 0 : filter.and) {
        params.filter = makeAndFiltersForQuery(filter.and);
    }
    if (filter === null || filter === void 0 ? void 0 : filter.or) {
        params._filter = makeOrFiltersForQuery(filter.or);
    }
    if (filter === null || filter === void 0 ? void 0 : filter.not) {
        params['-filter'] = makeNegativeFilterForQuery(filter.not);
    }
    if (facet) {
        params.facet = makeFacetsForQuery(facet);
    }
    if (slots_filter === null || slots_filter === void 0 ? void 0 : slots_filter.and) {
        params.slots_filter = makeAndFiltersForQuery(slots_filter.and);
    }
    if (slots_filter === null || slots_filter === void 0 ? void 0 : slots_filter.or) {
        params['_slots_filter'] = makeOrFiltersForQuery(slots_filter.or);
    }
    if (slots_filter === null || slots_filter === void 0 ? void 0 : slots_filter.not) {
        params['-slots_filter'] = makeNegativeFilterForQuery(slots_filter.not);
    }
    if (slots_facet) {
        params.slots_facet = makeFacetsForQuery(slots_facet);
    }
    return Object.assign(Object.assign({}, params), inputMinusFacetFilter);
};
//# sourceMappingURL=input.js.map